import { memo } from 'react';
import styled from 'styled-components';

const StyledTableBody = styled.tbody`
  margin: 0;
  padding: 0;

  /* Smooth visual transitions */
  transition: background-color 0.15s ease-in-out;

  /* Optional striped rows mode */
  ${({ $striped }) =>
    $striped &&
    `
    & tr:nth-child(odd) {
      background-color: #fafafa;
    }
  `}

  /* Optional body hover mode */
  ${({ $hoverable }) =>
    $hoverable &&
    `
    tr:hover {
      background-color: #f2f2f2;
    }
  `}

  /* Optional compact mode */
  ${({ $compact }) =>
    $compact &&
    `
      font-size: 13px;
  `}
`;

const TableBody = memo(
  ({ children, striped = false, hoverable = false, compact = false }) => (
    <StyledTableBody
      $striped={striped}
      $hoverable={hoverable}
      $compact={compact}
    >
      {children}
    </StyledTableBody>
  )
);

export default TableBody;
